// import { useState, useEffect } from "react";
// import Header from "../Dashboard/Header";
// import Home from "../Dashboard/Home";
// import avatar from "./../../assests/avatar.jpg";
// import systech_logo from "./../../assests/systech_logo.png";
// import verified_icon from "./../../assests/verified_icon.png";
// import { useAutoLogout } from "../hooks/UseAutoLogout";
// import LeftSidebar from "../Dashboard/LeftSidebar";
// import Migration from "../migrations/Migration";
// import { useAuth } from "../context/AuthContext";
// import { useNavigate } from "react-router-dom";
// import CustomButton from "../Buttons/CustomButton";
// import {
//   FaShieldAlt as ShieldCheck,
//   FaEdit as Edit,
//   FaTimes as X,
// } from "react-icons/fa";
// import HeaderRightContent from "../Dashboard/HeaderRightContent";
// import "../../App.css";
// import { Link } from "react-router-dom";
// import axios from "axios";

// const Profile = ({ activeTab, setActiveTab, setProfile, onEdit }) => {
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [overlayFlag, setOverlayFlag] = useState(false);
//   const [loading, setLoading] = useState(true);

//   // Profile data state
//   const [profileData, setProfileData] = useState({
//     name: "User",
//     email: "N/A",
//     company: "N/A",
//     contactPhone: "N/A",
//     country: "N/A",
//     timeZone: "UTC",
//     autopayDate: "N/A",
//     created_at: "N/A",
//     avatarImg: avatar,
//   });

//   // TextSkeleton component matching UserManagement styling
//   const TextSkeleton = ({ width = '100%', height = '16px', className = '', style = {} }) => (
//     <div
//       className={className}
//       style={{
//         width,
//         height,
//         backgroundColor: "rgba(0, 0, 0, 0.1)",
//         borderRadius: "4px",
//         animation: "pulse 1.5s infinite",
//         ...style
//       }}
//     />
//   );

//   // Your existing useEffect with API call
//   useEffect(() => {
//     const fetchProfileData = async () => {
//       const apiBaseProfileData = process.env.REACT_APP_API_URL_CODE_CONVERSION;
//       try {
//         setLoading(true);
//         const authToken = sessionStorage.getItem("access_token");
//         if (!authToken) throw new Error("Authentication token missing.");

//         const response = await axios.get(
//           `${apiBaseProfileData}/view_profile`,
//           { headers: { Authorization: `Bearer ${authToken}` } }
//         );

//         console.log(response.data, "DATA");
//         setProfile(response.data);
//         setProfileData((prev) => ({
//           ...prev,
//           firstName: response.data.first_name || prev.firstName,
//           lastName: response.data.last_name || prev.lastName || "",
//           email: response.data.email || prev.email,
//           company: response.data.company || prev.company,
//           created_at: response.data.created_at || prev.created_at || "",
//           contactPhone: response.data.contact_phone || prev.contactPhone || "",
//           country: response.data.country || prev.country,
//           timeZone: response.data.time_zone || prev.timeZone,
//           autopayDate: response.data.autopayDate || prev.autopayDate,
//           avatarImg: response.data.avatar || prev.avatar,
//         }));
//       } catch (error) {
//         console.error("Error fetching profile data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProfileData();

//     // Your existing effects
//     localStorage.setItem("activeTab", activeTab);

//     if (isCollapsed) {
//       document.body.classList.add("vertical-collpsed");
//     }
//     return () => {
//       document.body.classList.remove("vertical-collpsed");
//     };
//   }, [activeTab, isCollapsed]);

//   useAutoLogout();

//   const { state } = useAuth();
//   const navigate = useNavigate();

//   return (
//     <div id="home" className={`tab_content font-family-inter`} style={{marginTop:"-98px"}}>
//       <style>
//         {`
//           @keyframes pulse {
//             0% { opacity: 0.6; }
//             50% { opacity: 0.3; }
//             100% { opacity: 0.6; }
//           }
//         `}
//       </style>
//       <div>
//         <div className="page-content w-100">
//           <div className="container-fluid">
//             <div className="d-flex justify-content-between  align-items-center">
//               <div>
//                 {/* Breadcrumb skeletons or content based on loading state */}
//               </div>
//               <div className="d-flex gap-2">
//                 {/* Action buttons can be added here if needed */}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="profile_maindiv">
//           <div className="">
//             <div className="profile-container">
//               <div className="profile-header">
//                 <div className="avatar-container">
//                   <div className="avatar">
//                     {loading ? (
//                       <div
//                         style={{
//                           width: "80px",
//                           height: "80px",
//                           borderRadius: "50%",
//                           backgroundColor: "rgba(0, 0, 0, 0.1)",
//                           animation: "pulse 1.5s infinite"
//                         }}
//                       />
//                     ) : (
//                       <img
//                         className="avatar_style"
//                         src={
//                           profileData.avatarImg ? profileData.avatarImg : avatar
//                         }
//                         alt="Profile"
//                       />
//                     )}
//                   </div>
//                 </div>
//                 <div className="profile-content">
//                   <div
//                     className="profile-line_heading"
//                     style={{ display: "flex", justifyContent: "space-between" }}
//                   >
//                     <div
//                       style={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: "8px",
//                       }}
//                     >
//                       <div className="name">
//                         {loading ? (
//                           <TextSkeleton width="150px" height="24px" />
//                         ) : (
//                           profileData.firstName + " " + profileData.lastName || ""
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                   <div
//                     className="profile-line"
//                     style={{
//                       justifyContent: "space-between",
//                       marginTop: "8px",
//                     }}
//                   >
//                     <div className="email">
//                       {loading ? (
//                         <TextSkeleton width="200px" height="16px" />
//                       ) : (
//                         profileData.email
//                       )}
//                     </div>
//                     <div className="autopay">
//                       {loading ? (
//                         <TextSkeleton width="100px" height="16px" />
//                       ) : (
//                         new Date(profileData.created_at).toLocaleDateString(
//                           "en-US",
//                           {
//                             year: "numeric",
//                             month: "short",
//                             day: "2-digit",
//                           }
//                         )
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div
//               className="mt-4 mb-1 ms-3 me-2 pro-con"
//               style={{
//                 fontWeight: 500,
//                 fontFamily: "Inter",
//                 fontSize: "14px",
//                 lineHeight: "1.5",
//               }}
//             >
//               <div
//                 style={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                 }}
//               >
//                 <div style={{ fontWeight: 500, fontSize: "14px" }}>Company</div>
//                 <div>
//                   {loading ? (
//                     <TextSkeleton width="120px" height="16px" />
//                   ) : (
//                     profileData.company
//                   )}
//                 </div>
//               </div>

//               <div style={{ fontSize: "14px", display: "grid", gap: "12px" }}>
//                 <div
//                   className="mt-3"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <div>Contact Phone</div>
//                   <div>
//                     {loading ? (
//                       <TextSkeleton width="130px" height="16px" />
//                     ) : (
//                       profileData.contactPhone
//                     )}
//                   </div>
//                 </div>

//                 <div
//                   className="mt-2"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <div>Country</div>
//                   <div>
//                     {loading ? (
//                       <TextSkeleton width="80px" height="16px" />
//                     ) : (
//                       profileData.country
//                     )}
//                   </div>
//                 </div>

//                 <div
//                   className="mt-2"
//                   style={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                   }}
//                 >
//                   <div>Time Zone</div>
//                   <div>
//                     {loading ? (
//                       <TextSkeleton width="60px" height="16px" />
//                     ) : (
//                       profileData.timeZone
//                     )}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Profile;

import { useState, useEffect } from "react";
import avatar from "./../../assests/avatar.jpg";
import { useAutoLogout } from "../hooks/UseAutoLogout";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../../App.css";

const Profile = ({ activeTab, setActiveTab, setProfile }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [loading, setLoading] = useState(true);

  // Profile data state (start empty, no fallback "N/A")
  const [profileData, setProfileData] = useState(null);

  // TextSkeleton component
  const TextSkeleton = ({
    width = "100%",
    height = "16px",
    className = "",
    style = {},
  }) => (
    <div
      className={className}
      style={{
        width,
        height,
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        borderRadius: "4px",
        animation: "pulse 1.5s infinite",
        ...style,
      }}
    />
  );

  useEffect(() => {
    const fetchProfileData = async () => {
      const apiBaseProfileData = process.env.REACT_APP_API_URL_CODE_CONVERSION;
      try {
        setLoading(true);
        const authToken = sessionStorage.getItem("access_token");
        if (!authToken) throw new Error("Authentication token missing.");

        const response = await axios.get(`${apiBaseProfileData}/view_profile`, {
          headers: { Authorization: `Bearer ${authToken}` },
        });

        if (response?.data) {
          setProfile(response.data);
          setProfileData({
            firstName: response.data.first_name || "",
            lastName: response.data.last_name || "",
            email: response.data.email || "",
            company: response.data.company || "",
            created_at: response.data.created_at || "",
            contactPhone: response.data.contact_phone || "",
            country: response.data.country || "",
           
            timeZone: response.data.time_zone && response.data.time_zone.trim() !== "" 
  ? response.data.time_zone 
  : "UTC",

            autopayDate: response.data.autopayDate || "",
            avatarImg: response.data.avatar || avatar,
          });
        } else {
          setProfileData(null); // keep null so loader stays
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
        setProfileData(null); // loader instead of NA
      } finally {
        setLoading(false);
      }
    };

    fetchProfileData();

    localStorage.setItem("activeTab", activeTab);

    if (isCollapsed) {
      document.body.classList.add("vertical-collpsed");
    }
    return () => {
      document.body.classList.remove("vertical-collpsed");
    };
  }, [activeTab, isCollapsed, setProfile]);

  useAutoLogout();
  const { state } = useAuth();
  const navigate = useNavigate();

  return (
    <div
      id="home"
      className={`tab_content font-family-inter`}
      style={{ marginTop: "-98px" }}
    >
      <style>
        {`
          @keyframes pulse {
            0% { opacity: 0.6; }
            50% { opacity: 0.3; }
            100% { opacity: 0.6; }
          }
        `}
      </style>

      <div>
        <div className="page-content w-100">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center">
              <div></div>
              <div className="d-flex gap-2"></div>
            </div>
          </div>
        </div>

        <div className="profile_maindiv">
          <div className="profile-container">
            <div className="profile-header">
              <div className="avatar-container">
                <div className="avatar">
                  {loading || !profileData ? (
                    <div
                      style={{
                        // width: "80px",
                        // height: "80px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                        animation: "pulse 1.5s infinite",
                      }}
                    />
                  ) : (
                    <img
                      className="avatar_style"
                      src={profileData.avatarImg}
                      alt="Profile"
                    />
                  )}
                </div>
              </div>

              <div className="profile-content">
                <div
                  className="profile-line_heading"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <div className="name">
                      {loading || !profileData ? (
                        <TextSkeleton width="150px" height="24px" />
                      ) : (
                        `${profileData.firstName} ${profileData.lastName}`
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="profile-line"
                  style={{
                    justifyContent: "space-between",
                    marginTop: "8px",
                  }}
                >
                  <div className="email">
                    {loading || !profileData ? (
                      <TextSkeleton width="200px" height="16px" />
                    ) : (
                      profileData.email
                    )}
                  </div>
                  <div className="autopay">
                    {loading || !profileData ? (
                      <TextSkeleton width="100px" height="16px" />
                    ) : profileData.created_at ? (
                      new Date(profileData.created_at).toLocaleDateString(
                        "en-US",
                        { year: "numeric", month: "short", day: "2-digit" }
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Company + other details */}
          <div
            className="mt-4 mb-1 ms-3 me-2 pro-con"
            style={{
              fontWeight: 500,
              fontFamily: "Inter",
              fontSize: "14px",
              lineHeight: "1.5",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div style={{ fontWeight: 500, fontSize: "14px" }}>Company</div>
              <div>
                {loading || !profileData ? (
                  <TextSkeleton width="120px" height="16px" />
                ) : (
                  profileData.company
                )}
              </div>
            </div>

            <div style={{ fontSize: "14px", display: "grid", gap: "12px" }}>
              <div
                className="mt-3"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>Contact Phone</div>
                <div>
                  {loading || !profileData ? (
                    <TextSkeleton width="130px" height="16px" />
                  ) : (
                    profileData.contactPhone
                  )}
                </div>
              </div>

              <div
                className="mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>Country</div>
                <div>
                  {loading || !profileData ? (
                    <TextSkeleton width="80px" height="16px" />
                  ) : (
                    profileData.country
                  )}
                </div>
              </div>

              <div
                className="mt-2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>Time Zone</div>
                <div>
                  {loading || !profileData ? (
                    <TextSkeleton width="60px" height="16px" />
                  ) : (
                    profileData.timeZone
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
